import { __ } from "@wordpress/i18n";
import { SettingsContext } from "../Settings";
import { useContext } from "react";

const TranslationSettings = () => {
  const { settings, register } = useContext(SettingsContext);

  const TranslationStrings = [
    {
      title: __("Views", "feeds-for-youtube"),
      default: "viewstext",
      description: __(
        "Used for showing views. Example: 392k views",
        "feeds-for-youtube"
      ),
    },
    {
      title: __("Ago", "feeds-for-youtube"),
      default: "agotext",
      description: __(
        "Used for showing time. Example: 3d ago",
        "feeds-for-youtube"
      ),
    },
    {
      title: __("Streaming live", "feeds-for-youtube"),
      default: "beforedatetext",
      description: __(
        "Used to highlight when a video is streaming live",
        "feeds-for-youtube"
      ),
    },
    {
      title: __("Streaming live in", "feeds-for-youtube"),
      default: "beforestreamtimetext",
      description: __(
        "Used to highlight when a video is going to stream live",
        "feeds-for-youtube"
      ),
    },
    {
      title: __("Minutes", "feeds-for-youtube"),
      default: "minutestext",
      description: __(
        "Used to show length of the video. Example: 3 minutes 21 seconds",
        "feeds-for-youtube"
      ),
    },
    {
      title: __("Hours", "feeds-for-youtube"),
      default: "hourstext",
      description: __(
        "Used to show length of the video. Example: 1 hour 3 minutes",
        "feeds-for-youtube"
      ),
    },
    {
      title: __("Watch Now", "feeds-for-youtube"),
      default: "watchnowtext",
      description: __("To display the call to action", "feeds-for-youtube"),
    },
    {
      title: __("Thousands", "feeds-for-youtube"),
      default: "thousandstext",
      description: __(
        "Used in the number of views. Example: 321K videos",
        "feeds-for-youtube"
      ),
    },
    {
      title: __("Millions", "feeds-for-youtube"),
      default: "millionstext",
      description: __(
        "Used in the number of views. Example: 4.2M videos",
        "feeds-for-youtube"
      ),
    },
  ];

  return (
    <div className="sb-tab-box sb-custom-text-box d-flex">
      <div className="tab-label tab-label-full">
        <h3>{__("Custom Text/Translate", "feeds-for-youtube")}</h3>
        <span className="sb-help-text">
          {__(
            "Enter custom text for the words below, or translate it into the language you would like to use.",
            "feeds-for-youtube"
          )}
        </span>

        <div className="sb-tab-inner-card">
          <table className="sby-table">
            <thead>
              <tr>
                <th>{__("Original Text", "feeds-for-youtube")}</th>
                <th>{__("Custom text/translation", "feeds-for-youtube")}</th>
                <th>{__("Context", "feeds-for-youtube")}</th>
              </tr>
            </thead>
            <tbody>
              {TranslationStrings.map((string) => {
                return (
                  <tr key={string.title}>
                    <td>{string.title}</td>
                    <td>
                      <input
                        type="text"
                        className="sby-input"
                        defaultValue={settings[string.default]}
                        {...register(string.default)}
                      />
                    </td>
                    <td>{string.description}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default TranslationSettings;
